import React from 'react';
import { Button, IconButton_IconSizes } from '@ydistri/ds';
import { MdAdd } from 'react-icons/md';

const createIcon = <MdAdd size={IconButton_IconSizes.small} />;

interface CreateAsoButtonProps {
  onClick: () => void;
  title: string;
  disabled?: boolean;
}

export const CreateAsoButton: React.FC<CreateAsoButtonProps> = ({ onClick, title, disabled }) => {
  return (
    <Button
      $textVariant="semibold"
      icon={createIcon}
      type="primary"
      onClick={onClick}
      disabled={disabled}
    >
      {title}
    </Button>
  );
};
